var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-content":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"text-center"},[_vm._v("Not found")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }